module.exports = __webpack_public_path__ + "img/img-logo-leed.328383c6.png";